var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "skin-setting" },
    [
      _c(
        "el-card",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticClass: "skin-card",
          attrs: {
            "element-loading-text": _vm.loadingText,
            "element-loading-spinner": "el-icon-loading",
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "header",
              attrs: { slot: "header" },
              slot: "header",
            },
            [
              _c("div", [_vm._v("装修设置")]),
              _vm._v(" "),
              _c(
                "div",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", size: "mini", plain: "" },
                      on: { click: _vm.closeSkin },
                    },
                    [_vm._v("返回列表")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "primary",
                        loading: _vm.isLoading,
                        size: "mini",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.saveSkin(2)
                        },
                      },
                    },
                    [_vm._v("发布")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "primary",
                        loading: _vm.isLoading,
                        size: "mini",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.saveSkin(1)
                        },
                      },
                    },
                    [_vm._v("保存")]
                  ),
                ],
                1
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "skin-setting-view" },
            [
              _c("SkinNav", {
                ref: "SkinNavRef",
                staticClass: "skin-nav-section",
                on: { addComItems: _vm.addCompont },
              }),
              _vm._v(" "),
              _c("SkinPreview", {
                ref: "SkinPreviewRef",
                staticClass: "skin-preview-section",
                attrs: { showType: 2 },
              }),
              _vm._v(" "),
              _c("SkinView", {
                ref: "SkinViewRef",
                staticClass: "skin-view-section",
                attrs: { detailInfos: _vm.detailInfos },
                on: { showPreviewSkin: _vm.showPreviewSkin },
              }),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }